import { Navigate } from "react-router";
import { usePermissions } from "../../hooks/usePermissions";

/**
 * Componente que redireciona para a primeira página disponível
 * baseada nas permissões do usuário.
 * 
 * Usado principalmente após login para direcionar o usuário
 * para a primeira área que ele tem permissão.
 */
export function FirstAvailableRedirect() {
    const { getFirstAvailableRoute, loading } = usePermissions();

    // Durante o carregamento, mostra loading
    if (loading) {
        return (
            <div className="flex min-h-screen items-center justify-center">
                <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-200 border-t-blue-600"></div>
            </div>
        );
    }

    // Redireciona para a primeira rota disponível
    const targetRoute = getFirstAvailableRoute();

    return <Navigate to={targetRoute} replace />;
}
